//#region IMPORT
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import M_Master_NEW from './M_Master_NEW';
//#endregion

function M_Master_NEWF() {
  //#region 변수
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.common.activeStep);
  //#endregion

  //#region 이벤트
  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('보호구'));
    dispatch(CommonActions.resetActiveStep());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion

  //#region 이벤트 핸들러
  const HandleTabChange = (event, newValue) => {
    dispatch(CommonActions.setActiveStep(newValue));
  };
  //#endregion

  return (
    <div className="wrap">
      <M_Master_NEW activeTab={activeTab} onTabChange={HandleTabChange} />
    </div>
  );
}

export default M_Master_NEWF;
